(function () {
  'use strict';

  angular.module('app').component('vehiclesPage', vehicleListComponent());

  function vehicleListComponent() {
    return {
      controller: VehicleListCrtl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/vehicles/vehicles-page.component.html',
    };
  }

  VehicleListCrtl.$inject = ['$location', 'AbilityService', 'VehicleService', 'LanguageService'];

  function VehicleListCrtl($location, AbilityService, VehicleService, LanguageService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.permissions = {
      canCreate: AbilityService.can('create_vehicle_accountadmin'),
    };

    // Initializers
    getDefaultLanguage();

    // public methods
    // -----------------------
    vm.createItem = function () {
      $location.path('/vehicles/new');
    };

    vm.onShowItem = function (item) {
      $location.path(`/vehicles/${item.id}`);
    };

    // private methods
    // -----------------------
    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getItems();
      });
    }

    function getItems() {
      vm.filterCriteria = VehicleService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      VehicleService.getVehicles(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }
  }
})();
